const state = {
  menu: []

}
const getters = {
  getMenu: (state) => {
    return state.menu ? state.menu : null
  }
}
const actions = {
  async createMenu ({
    dispatch,
    commit,
    rootState,
    rootGetters
  }, essentialInfo) {
    const newMenu = []
    // check to see if we need to hide the Invoice Refund
    const refundLetter = rootGetters['booking/getRefundLetter']
    essentialInfo.forEach((item) => {
      // message carries free text notes hung off the menu item itself (e.g. the
      // Ryanair notes vt-api adds to Air Travel) rather than looked up by code
      const menuItem = { title: item.title, showsubmenu: false, partial: item.partial, payload: item.payload, sqlCodes: item.sqlCodes, message: item.message }
      if (item.submenu && item.submenu.length > 0) {
        // if refundLetter = false / null loop over submenu and look for partial -"CancellationInvoiceRef" and remove it from the array
        let newArray = item.submenu
        if (refundLetter !== true) {
          newArray = item.submenu.filter(function (el) {
            return el.partial !== 'CancellationInvoiceRef'
          })
        }
        menuItem.submenu = newArray
      }
      newMenu.push(menuItem)
    })
    if (newMenu) {
      return commit('menuCreated', newMenu)
    }
  }
}

const mutations = {
  menuCreated (state, newMenu) {
    // VisaInfo.content = HTTP Service loopkup for Visa Information
    state.menu = newMenu
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
